<template>
  <!-- Navbar -->
  <nav class="main-header navbar navbar-expand" style="border-bottom: #ffc107 solid 10px;">
    <!-- Left navbar links -->
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link" data-widget="pushmenu" href="#" role="button" style="color: aliceblue;font-size: large;">
          <i class="fas fa-align-left"></i>
        </a>
      </li>
      <li class="nav-item d-none d-sm-inline-block">
        <img class="animation__shake" src="../assets/img/logo_pu.jpg" style="height: 30px;">
      </li>
      <li class="nav-item d-none d-sm-inline-block">
        <a href="#" class="nav-link animation__shake" style="color: aliceblue;">Loan Management System</a>
      </li>
    </ul>

    <!-- Right navbar links -->
    <ul class="navbar-nav ml-auto">
      <li class="nav-item d-none d-sm-inline-block">
        <a href="#" class="nav-link animation__shake" style="color: #ffc107;text-align: right;">{{ datauser.name }}, {{
          datauser.userGroup }}</a>
      </li>
      <!-- Notifications Dropdown Menu -->
      <li class="nav-item dropdown">
        <a class="nav-link" data-toggle="dropdown" href="#" style="color: aliceblue;">
          <b><i class="far fa-user"></i></b>
        </a>
        <div class="dropdown-menu dropdown-menu-right">
          <a href="/Profil" class="dropdown-item">
            <i class="fas fa-user mr-2"></i> Profil
          </a>
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item" v-on:click="logoutAct">
            <i class="fas fa-sign-out-alt mr-2"></i> Logout
          </a>
        </div>
      </li>
      <li class="nav-item">
        <a class="nav-link" data-widget="fullscreen" href="#" role="button" style="color: aliceblue;">
          <i class="fas fa-expand-arrows-alt"></i>
        </a>
      </li>
    </ul>
  </nav>
  <!-- /.navbar -->
</template>

<script>
export default {
  data() {
    return {
      datauser: '',
    }
  },
  methods: {
    getUser() {
      this.datauser = JSON.parse(localStorage.getItem("userLogin"));
    },
    async logoutAct() {
      localStorage.removeItem('token');
      localStorage.removeItem('userLogin');
      localStorage.removeItem('TahunAktif');
      window.location.replace("/");
    }
  },
  mounted() {
    this.getUser();
  },
}
</script>

<style></style>